<div class="tw-w-full tw-py-4 tw-bg-white tw-my-3">
  <div class="tw-flex tw-justify-between tw-items-center tw-font-lexend tw-my-2 tw-pl-4 tw-pr-2">
    <h3 class="tw-text-gray-900 tw-font-medium tw-text-400" i18n="@@whatsInsideYourKit"> What's inside your kit </h3>
    <h3 class="tw-flex tw-items-center tw-text-teal-600 tw-text-400 tw-font-bold" (click)="goToInstructions()">
      <span i18n="@@readMore" class="tw-tracking-[0.01px]">Read More</span>
      <cs-icon class="tw-h-4 tw-w-4 tw-ml-1 tw-text-teal-600 tw-animate-bounce_x" [iconName]="'chevron_right'"></cs-icon>
    </h3>
  </div>
  <swiper [config]="swiperConfig">
    @for (slide of slides(); track slide.objectId; let i = $index) {
      <div *swiperSlide class="tw-py-4" [class]="i === slides().length - 1 ? 'tw-px-4' : 'tw-pl-4'" (click)="goToProductDetails(slide.product)">
        <div class="tw-w-full tw-bg-gray-100 tw-flex tw-justify-center tw-items-center tw-rounded-5 tw-overflow-hidden tw-h-[370px] tw-relative">
          <div class="tw-absolute tw-top-3 tw-right-3 tw-text-100 tw-font-lexend">{{ slide.quantityLabel }}</div>
          <img [src]="slide.imageLink" [alt]="slide.title" class="tw-w-full tw-h-full" [class]="slide.isTagged ? 'tw-object-cover' : 'tw-object-contain tw-mb-4'" />
          <div class="tw-absolute tw-bottom-5 tw-left-5">
            <div class="tw-px-2 tw-bg-white tw-rounded-1 tw-text-100 tw-mb-1.5 tw-w-fit tw-tracking-wide">PRODUCT {{ i + 1 }}</div>
            @if (slide.isTagged) {
              <div class="tw-w-2/3">
                <div class="tw-text-300 tw-font-lexend tw-font-normal tw-leading-5" [innerHTML]="slide.title"></div>
              </div>
            } @else {
              <div class="tw-flex tw-flex-col tw-gap-0">
                <span class="tw-text-300 tw-font-lexend tw-tracking-[0.25px]">{{ slide.title }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </swiper>
  <div class="tw-mb-4 tw-px-4">
    <button csButton="outlined" size="small" type="button" class="tw-w-full" (click)="goToInstructions()">
      <span i18n="@@KnowHowToUseYourProducts"> Know how to use products </span>
    </button>
  </div>
</div>
